import { useContext } from "react";
import { useIntl } from "react-intl";

import { ProgressDialog, ProgressDialogItem } from "@/components/progress-dialog";

import { FileUploadingContext } from "..";

export function FileUploadingDialog() {
  const intl = useIntl();
  const { filesBeingUploaded, showFileModal, cancelUpload } = useContext(FileUploadingContext);

  const visibleFiles = filesBeingUploaded.filter((f) => !f.withoutProgressDialog);
  const loadingCount = visibleFiles.filter((f) => f.status === "loading").length;

  const title =
    loadingCount > 0
      ? intl.formatMessage(
          {
            id: "uploading.uploading_files",
            defaultMessage: "Uploading {loadingFilesLength, plural, one {# file} other {# files}}",
          },
          { loadingFilesLength: loadingCount }
        )
      : intl.formatMessage({ id: "uploading.done", defaultMessage: "Done" });

  const items: ProgressDialogItem[] = visibleFiles.map((f) => ({
    id: f.number,
    label: f.file.name,
    sublabel: f.status === "error" ? f.error : undefined,
    status: f.status === "loading" ? "inProgress" : f.status,
    progress: f.status === "loading" && "progress" in f ? f.progress : undefined,
    onCancel: f.status === "loading" ? () => cancelUpload(f.number) : undefined,
  }));

  return <ProgressDialog defaultIsOpen title={title} items={!showFileModal ? [] : items} />;
}
